import EmptyState from "../components/ds/EmptyState";
import Page from "../components/ds/Page";
import { useTranslation } from "../context/TranslationContext";

/** A page whose feature isn't built yet (Figma B17 search, B18 invite creators). */
const EmptyPage = ({ page }) => {
  const { t } = useTranslation();

  return (
    <Page>
      <div className="flex min-h-[60vh] items-center justify-center rounded-radius-lg bg-bg-raised">
        <EmptyState
          icon={page === "search" ? "search" : "users"}
          title={t(`emptyPages.${page}Title`)}
          message={t(`emptyPages.${page}Description`)}
        />
      </div>
    </Page>
  );
};

export default EmptyPage;
